import React from 'react';
import { EpcWbsLibraryWorkspace } from './EpcWbsLibraryWorkspace';

export const EpcWbsLibraryPage: React.FC = () => <EpcWbsLibraryWorkspace />;

export default EpcWbsLibraryPage;
